///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';

export class GtthAbortDesignCommand extends GtthAbstractCommand {
    getCommandName(): string {
        return 'GtthAbortDesignCommand';
    }

    protected doCommand(): void {
        const abortDesignActivity = this.createActivityDTO(false);
        this.sendActivity(abortDesignActivity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            this.historyService.notificationService.showError(activityDto?.error?.message);
            this.commandResolve(false);
        } else {
            this.commandResolve(true);
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
